export default __webpack_public_path__ + "assets/models/4e178d2050901f56967fde7dae76f6dc.gltf";